import React from 'react'
import { css, StyleSheet } from 'aphrodite/no-important'

import { colors } from '@lmc/common/constants'
import TextField from '../../../fields/types/TextField'
import { Icon } from '@lmc/ui-kit'

interface EmarCustomMedNameFieldProps {
  onCancel: () => void
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  values: Record<string, any>
  testId?: string
}

export default function EmarCustomMedNameField(
  props: EmarCustomMedNameFieldProps
): JSX.Element {
  const { onCancel, onChange, values, testId } = props

  return (
    <div
      style={styles.fieldSubContainer}
      data-testid={
        testId ? `${testId}-custom-med-name-field` : 'custom-med-name-field'
      }
    >
      {/* @ts-ignore */}
      <TextField
        formKey="medicationName"
        layout="no-label"
        onChange={onChange}
        values={values}
        data-testid={
          testId ? `${testId}-custom-med-name-input` : 'custom-med-name-input'
        }
      />
      <div
        className={css(classes.cancelContainer)}
        id="cancelContainer"
        onClick={onCancel}
        data-testid={
          testId ? `${testId}-custom-med-name-cancel` : 'custom-med-name-cancel'
        }
      >
        {/* @ts-ignore */}
        <Icon name="CloseOutlined" style={styles.cancelIcon} />
      </div>
    </div>
  )
}

const classes = StyleSheet.create({
  cancelContainer: {
    ':hover': {
      color: colors.red
    },
    cursor: 'pointer',
    margin: '0px 8px 0px 16px'
  }
})

const styles = {
  cancelIcon: {
    fontSize: 15
  },
  fieldSubContainer: {
    alignItems: 'center',
    background: colors.white,
    display: 'flex',
    marginTop: 10
  }
}
